/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/brush_medium'
export default icon
